import { css } from 'emotion';

import { colors, fonts, icons } from '@cobliteam/base-components/src/styles';

export const cluster = css`
  display: flex;
  min-width: 40px;
  padding: 3px 5px;
  border-radius: 10px;
  color: ${colors.white};
  height: ${icons.size.medium};
  background: ${colors.secondary.default};
  border: 1px solid ${colors.white};
  font-weight: ${fonts.weight.medium};
  filter: drop-shadow(
    0px 4px 4px ${colors.shadows.getShadow(colors.secondary.default, 0.2)}
  );
  transform: translateX(-50%);
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  & > span {
    min-width: 14px;
    text-align: center;
  }
`;
